/* AuraVane gift finder: builds the best collection URL from 3 choices. No dependencies. */
(function (root) {
  'use strict';
  /* mode "path": /collections/gifts-for-mom/occasion:birthday+type:mug (tag URL, works with no admin setup)
     mode "filter": /collections/gifts-for-mom?filter.p.tag=occasion:birthday&filter.p.tag=type:mug (needs the Tag filter in Search & Discovery) */
  function buildUrl(o) {
    if (!o || !o.who) return '';
    var base = (o.base || '/collections').replace(/\/$/, '') + '/' + encodeURIComponent(o.who);
    var tags = [];
    if (o.occasion) tags.push((o.occPrefix || 'occasion') + ':' + o.occasion);
    if (o.type) tags.push((o.typePrefix || 'type') + ':' + o.type);
    if (!tags.length) return base;
    if (o.mode === 'filter') {
      return base + '?' + tags.map(function (t) { return 'filter.p.tag=' + encodeURIComponent(t); }).join('&');
    }
    return base + '/' + tags.map(function (t) { return t.split(':').map(encodeURIComponent).join(':'); }).join('+');
  }

  function init(el) {
    var cta = el.querySelector('[data-gf-go]');
    var live = el.querySelector('[data-gf-live]');
    var app = el.querySelector('[data-gf-app]');
    var fb = el.querySelector('[data-gf-fallback]');
    if (!cta || !app) return;
    var d = el.dataset;
    function val(name) {
      var r = el.querySelector('input[name="' + name + '"]:checked');
      return r ? r : null;
    }
    // 2026-10-12 audit: a chip the chosen collection cannot fill is hidden (falls back to "Just because" / "Any"), and the
    // final URL is checked (?view=gfcount -> {"count":n}); an empty combination is widened (drop type, then occasion).
    function prune(w) {
      var tags = (w && w.dataset.tags) || '';
      [['gf-occasion', d.occPrefix || 'occasion'], ['gf-type', d.typePrefix || 'type']].forEach(function (g) {
        Array.prototype.forEach.call(el.querySelectorAll('input[name="' + g[0] + '"]'), function (r) {
          var ok = !r.value || !tags || tags.indexOf('|' + (g[1] + ':' + r.value).toLowerCase() + '|') !== -1;
          var opt = r.closest('.av-gf__opt');
          if (opt) opt.hidden = !ok;
          r.disabled = !ok;
          if (!ok && r.checked) {
            r.checked = false;
            var any = el.querySelector('input[name="' + g[0] + '"][value=""]');
            if (any) any.checked = true;
          }
        });
      });
    }
    var seq = 0;
    function count(url) {
      return fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'view=gfcount', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { count: 0 }; })
        .then(function (j) { return +j.count || 0; }, function () { return -1; });
    }
    function verify(o, my) {
      var tries = [o, Object.assign({}, o, { type: '' }), Object.assign({}, o, { type: '', occasion: '' })];
      (function next(i) {
        if (i >= tries.length || my !== seq) return;
        var url = buildUrl(tries[i]);
        count(url).then(function (n) {
          if (my !== seq) return;
          if (n === 0 && i < tries.length - 1) return next(i + 1);
          cta.href = url;
          if (i > 0 && live) live.textContent = 'Nothing in that exact mix yet. Closest match: ' +
            (i === 1 && o.occLabel ? 'all ' + o.occLabel + ' gifts for ' : 'everything for ') + (o.whoLabel || '') + '.';
        });
      })(0);
    }
    function update(e) {
      if (e && e.target && e.target.name === 'gf-who') prune(e.target);
      var w = val('gf-who'), oc = val('gf-occasion'), ty = val('gf-type');
      if (!w) {
        cta.setAttribute('aria-disabled', 'true');
        cta.removeAttribute('href');
        if (live) live.textContent = d.hint || '';
        return;
      }
      var o = {
        base: d.base, mode: d.mode, occPrefix: d.occPrefix, typePrefix: d.typePrefix,
        who: w.value, whoLabel: w.dataset.label, occLabel: oc && oc.value ? oc.dataset.label : '', occasion: oc ? oc.value : '', type: ty ? ty.value : ''
      };
      cta.href = buildUrl(o);
      cta.removeAttribute('aria-disabled');
      if (live) live.textContent = [w.dataset.label, oc && oc.dataset.label, ty && ty.dataset.label].filter(Boolean).join(' / ');
      if (typeof fetch === 'function' && (o.occasion || o.type)) verify(o, ++seq); else seq++;
    }
    el.addEventListener('change', update);
    cta.addEventListener('click', function (e) {
      if (cta.getAttribute('aria-disabled') === 'true') { e.preventDefault(); if (live) live.focus(); }
    });
    if (fb) fb.hidden = true;
    app.hidden = false;
    prune(val('gf-who'));
    update();
  }

  if (typeof document !== 'undefined') {
    Array.prototype.forEach.call(document.querySelectorAll('[data-gift-finder]'), init);
    document.addEventListener('shopify:section:load', function (e) {
      var n = e.target && e.target.querySelector && e.target.querySelector('[data-gift-finder]');
      if (n) init(n);
    });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { buildUrl: buildUrl };
})(this);
